import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "./ErrorBoundary";
import { LandingPage } from "./Landing";
import "./styles.css";

const App = lazy(() => import("./App"));

const path = window.location.pathname.replace(/\/$/, "") || "/";
const isPlay = path === "/play" || path.endsWith("/play");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      {isPlay ? (
        <Suspense
          fallback={
            <div className="auth-screen">
              <div className="auth-card">
                <p className="muted">Leitstelle wird geladen…</p>
              </div>
            </div>
          }
        >
          <App />
        </Suspense>
      ) : (
        <LandingPage />
      )}
    </ErrorBoundary>
  </StrictMode>,
);
